import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var DropDownOptions = require("components/utility/DropDownOptions");
var EditableGoals = require("components/org/roster/EditableGoals");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");

require("org/preferences/grade_level_expectations_preference.scss");

@connect(
	(state, props) => {
		var refPrefs = {}

		// USER IS A TEACHER
		if (CurrentUser.isTeacherAdmin()) {
			var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
			if (admin && admin.prefs) {
				refPrefs = admin.prefs;
			}
		} else {
			// USER IS DISTRICT ADMIN
			if (CurrentUser.isDistrictAdmin()) {
				var selectedOrgs = RosterSelectors.districtOrgs({
					state, conditions: { ids: [CurrentUser.get().primary_district_org_id] }
				})
			} else {
				// USER IS SCHOOL ADMIN
				var selectedOrgs = RosterSelectors.schoolOrgs({
					state, conditions: { ids: [CurrentUser.get().primary_school_org_id] }
				})
			}

			if (selectedOrgs.length > 0) {
				refPrefs = selectedOrgs[0].prefs
			}
		}
		
		return {
			refPrefs
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            if (CurrentUser.isDistrictAdmin()) {
            	return Promise.all([ dispatch(RosterActions.fetchDistrictOrgs({
	                filters:{ids: [CurrentUser.get().primary_district_org_id]}, 
	                embeds:['district_org.prefs'],
	                cache: true
	            }))])
            } else if (CurrentUser.isSchoolAdmin()) {
            	return Promise.all([ dispatch(RosterActions.fetchSchoolOrgs({
	                filters:{ids: [CurrentUser.get().primary_school_org_id]}, 
	                embeds:['school_org.prefs'],
	                cache: true
	            }))])
            } else {
            	return Promise.all([ dispatch(RosterActions.fetchAdmins({
	                filters:{ids: [CurrentUser.get().id]}, 
	                embeds:['user.prefs'],
	                cache: true
	            }))])
            }
            return Promise.all([])
        },

		onChange: (prefsUpdate) => {
			// WE NEED TO RELOAD PAGE TO PREVENT HAVING STUDENT LISTS WITH WRONG PREFERENCES
			var confirmMessage = "Do you want to apply this setting to corresponding students/classes? Selecting yes will override the individual student and class preferences you may have set."
			var resetStudentLists = false

			if (CurrentUser.isTeacherAdmin()) {
				
				if (confirm(confirmMessage)) {
					resetStudentLists = true
				}
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: "Grade level expecations were saved!", icon: "ok-sign"
				});
				return dispatch( RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}), window.location.reload())
			} else {

				confirmMessage = confirmMessage.replace("you may", "you or other teachers or admins may")
				if (confirm(confirmMessage)) {
					resetStudentLists = true
				}
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: "Grade level expecations were saved!", icon: "ok-sign"
				});

				if (CurrentUser.isDistrictAdmin()) {
					return dispatch(RosterActions.updateDistrictOrgPrefs({
						currentUserID: CurrentUser.get().id,
						resetPrefs: resetStudentLists,
						districtOrgID: CurrentUser.get().primary_district_org_id,
						update: prefsUpdate
					}), window.location.reload())
				} else if (CurrentUser.isSchoolAdmin()) {
					return dispatch(RosterActions.updateSchoolOrgPrefs({
						currentUserID: CurrentUser.get().id,
						resetPrefs: resetStudentLists,
						schoolOrgID: CurrentUser.get().primary_school_org_id,
						update: prefsUpdate
					}), window.location.reload())
				}
			}
		}
	})
)

@providePopulateData({waitForLoad:true})
class GradeLevelExpectationsPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("GradeLevelExpectationsPreference");
		var defaultGrade = (CurrentUser.get().grade_level && CurrentUser.get().grade_level != 'unknown grade') ? parseInt(CurrentUser.get().grade_level) : 5
		this.state = {selectedGradeLevel: defaultGrade, refPrefs: props.refPrefs}
	}

	
	selectGradeLevel(selectedGradeLevel) {
		this.setState({selectedGradeLevel: parseInt(selectedGradeLevel.target.value)})
	}
	
	editGradeLevelPrefs(change, callback) {
		var refPrefs = this.state.refPrefs

		refPrefs = {...refPrefs, ...change}

		if (callback) {
			callback()
		} else {
			this.setState({refPrefs, save: true})
		}
	}

	getGradeLevel() {
		return this.state.selectedGradeLevel.toString()
	}

 	render() {
		if (this.state.save) {
			var saveAction = (
				<div className="saveExpectationPeriod text-center">
					<button className="btn btn-primary" onClick={this.onSave.bind(this)}>Save</button>
				</div>
			)
		}

		if (this.state.refPrefs && this.getGradeLevel()) {
			var quizGoals = <EditableGoals gradeLevel={ this.getGradeLevel()} prefs={this.state.refPrefs} onEditPrefs={this.editGradeLevelPrefs.bind(this)} quiz />
			var supplementalGoals = <EditableGoals gradeLevel={ this.getGradeLevel()} prefs={this.state.refPrefs} onEditPrefs={this.editGradeLevelPrefs.bind(this)} supplemental />
		}

		return (
			<div className="gradeLevelExpecationsPreference">
				<p>Your students will be instructed to complete the following activities:</p>

				<div className="row gradeLevelSelection">
					<div className="col-sm-4">
						Academic Grade Level:
					</div>
					<div className="col-sm-8">
						<select value={ this.state.selectedGradeLevel } className="form-control gradeSelect"
							onChange={ this.selectGradeLevel.bind(this) }>
							{ DropDownOptions.Select.GradeLevels() }
						</select>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-6">
						{ quizGoals }
					</div>
					<div className="col-sm-6">
						{ supplementalGoals }
					</div>
				</div>
				{ saveAction }
			</div>
		)
	}

	onSave() {
		var prefsUpdate = {"grade_level_expectations_metrics": this.state.refPrefs["grade_level_expectations_metrics"],
			"grade_level_question_count": this.state.refPrefs["grade_level_question_count"]}

		this.props.onChange(prefsUpdate)
		this.setState({save: false})
	}
	
	componentDidUpdate(prevProps) {
		if (prevProps.refPrefs.expectations_time_period != this.props.refPrefs.expectations_time_period ||
		prevProps.refPrefs.expectations_time_period_starts != this.props.refPrefs.expectations_time_period_starts ) {
			this.setState({refPrefs: this.props.refPrefs})
		}
	}

}

var ALL_GRADES = ["PK", "K", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "Mixed"] 
var QUESTION_COUNTS = ["recall_question_count", "analysis_question_count", "sentence_starter_count", ]

GradeLevelExpectationsPreference.WrappedComponent.propTypes = StrictPropTypes({
	populateData: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	refPrefs: PropTypes.object
});

module.exports = GradeLevelExpectationsPreference;


// WEBPACK FOOTER //
// ./modules/components/org/preferences/GradeLevelExpectationsPreference.js